export default "__VITE_ASSET__t2i0CNP4__"